<div class="node-template">
    <div *ngIf="!data()?.isStats && !data()?.isShowMore" class="asset-node"
        [ngStyle]="{ 'border' : 'solid 3px ' + data()?.borderColor, 'width' : '37rem', borderRadius: '1rem', backgroundColor: '#fff','height' : '10rem' }">
        <div class="node-title">
            {{ 'NETWORK_ASSET.NODE.LABEL.' + data()?.label | translate }}
        </div>
        <hr>
        <div class="asset-name">
            {{ data()?.name }}
        </div>

        <handle type="source" position="bottom" />
        <handle type="target" position="top" />
    </div>

    <div *ngIf="data()?.isStats" class="asset-node" [ngStyle]="{ 'border' : 'solid 3px #A81894', borderRadius: '1rem', backgroundColor: '#fff', 'width' : '37rem'}">
        <div class="node-title">
            {{ 'NETWORK_ASSET.NODE.STATS.' + data()?.label | translate }}
        </div>
        <hr>
        <div class="asset-name row" *ngFor="let stat of data()?.statistics">
            <div class="col-7">
                {{ 'NETWORK_ASSET.NODE.STATS.' + stat.key | translate }}
            </div>
            <div class="col-3">
                {{ stat.value | number : "1.0-0" }}
            </div>
            <div (click)="openListPage(stat.key, data()?.id, data()?.parentType)" class="col-2">
                <svg *ngIf="stat.key != 'Feeder 11kV'" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M14 16L17.2929 12.7071C17.6834 12.3166 17.6834 11.6834 17.2929 11.2929L14 8M7 16L10.2929 12.7071C10.6834 12.3166 10.6834 11.6834 10.2929 11.2929L7 8"
                        stroke="#A71894" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </div>
        </div>

        <handle type="target" position="top" />

    </div>
</div>

<div (click)="showMore(data())" *ngIf="data()?.isShowMore" class="more-node"
    [ngStyle]="{ 'border' : 'solid 3px ' + data()?.borderColor, borderRadius: '1rem', 'width' : '9rem',  backgroundColor: '#fff', 'height' : '10rem', cursor: 'pointer' }"
    data-bs-toggle="modal" data-bs-target="#moreoptions">
    <div class="asset-name-plus">
        {{ data()?.name }}
    </div>
    <div class="asset-name">
        {{ 'NETWORK_ASSET.NODE.MORE' | translate }}
    </div>
    <handle type="target" position="top" />
</div>